import React, { useState,useEffect } from 'react'
import Cards from './Cards';
import {firestore} from '../../Firebase/firebaseConfig';



function Quickexplore(props) {
   
    let sName = props.history.location.pathname.slice(10)
    const [state, setState] = useState({ arr : [],sName :'' })
    useEffect(() => {
        firestore.collection("Services").doc(sName).get().then(doc=>
        setState({arr : doc.data().data,sName : sName})    
        )
        return () => {
            setState({ arr : [] })
        }
    }, [sName])
   
    const back=()=>{
        props.history.goBack()
    }

    return (
        <Cards vendorArray={state.arr} back={back} sName={state.sName} />
    )
}

export default Quickexplore
